<script>
export default {
  data () {
    return {
      rmsITrendOption: {
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            var relVal = params[0].name
            for (var i = 0, l = params.length; i < l; i++) {
              relVal += '<br/>' + params[i].marker + params[i].seriesName + `&nbsp;&nbsp;&nbsp;&nbsp;` + params[i].value + 'A'
            }
            return relVal
          }
        },
        grid: {
          y2: 40
        },
        legend: {
          data: ['A相', 'B相', 'C相'],
          // right: 30,
          top: 20,
          formatter: ''
        },
        toolbox: {
          show: true,
          feature: {}
        },
        calculable: true,
        xAxis: [{
          type: 'category',
          name: 'h',
          data: [-24, -20, -16, -12, -8, -4, 0]
        }],
        yAxis: [{
          type: 'value',
          name: 'A',
          axisLabel: {
            // formatter: '{value} %'
          }
        }],
        series: [{
          name: 'A相',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#fccc00'
          },
          data: [0.00, 5.00, 0.00, 6.00, 0.00, 9.00, 0.00]
        }, {
          name: 'B相',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#009800'
          },
          data: [7.00, 4.00, 6.00, 1.00, 5.00, 8.00, 3.00]
        }, {
          name: 'C相',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#ff0000'
          },
          data: [4.00, 5.00, 2.00, 1.00, 8.00, 5.00, 3.00]
        }]
      },
      rmsITrendChart: {}
    }
  },
  mounted () {
    this.rmsITrendChart = this.$echarts.init(document.getElementById('rmsITrendChartOptions'))
    this.rmsITrendChart.setOption(this.rmsITrendOption)
  },
  methods: {
  }
}
</script>

<template>
  <div class="pg">
    <div class="dataItems">
      <div class="title">24小时电流RMS值趋势图界面</div>
      <div style="height: calc(100% - 40px);">
        <div id="rmsITrendChartOptions" style="height: 100%; width: 100%"></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "../../../assets/css/stable.css";
.pg {
  height: calc(45vh - 50px);
}

.dataName {
  width: 15%;
}

.dataValue {
  width: 8%;
//border-right: 1px solid black;
}

.dataNvItem {
  height: calc((100% - 70px)/11);
}
</style>



// WEBPACK FOOTER //
// src/pages/Trend/RmsTrend/RmsITrend.vue